module.exports = __webpack_public_path__ + "img/ic-battery.b812bb19.svg";